export function StepNav({
  label,
  steps,
  step,
  reachable,
  onPick,
}: {
  label: string;
  steps: readonly string[];
  step: number;
  /** Steps after this one are not open yet. */
  reachable: number;
  onPick: (s: number) => void;
}) {
  return (
    <nav aria-label={label} className="flex flex-wrap items-center gap-3.5">
      {steps.map((name, i) => (
        <span key={name} className="flex items-center gap-3.5">
          {i > 0 && <span aria-hidden className="h-px w-10 bg-input" />}
          <button
            type="button"
            disabled={i > reachable}
            aria-current={i === step ? "step" : undefined}
            onClick={() => onPick(i)}
            className="flex items-center gap-2 text-[13px] font-medium disabled:text-dim"
          >
            <span
              className={`flex size-6 items-center justify-center rounded-full border-[1.5px] text-xs font-semibold ${
                i === step
                  ? "border-primary bg-primary text-on-primary"
                  : i < step
                    ? "border-run-bg bg-run-bg text-link"
                    : "border-drop-border"
              }`}
            >
              {i < step ? "✓" : i + 1}
            </span>
            {name}
          </button>
        </span>
      ))}
    </nav>
  );
}
